import getConfig from 'next/config';

export const ENV_IDENTIFIER = {
  LOCAL: 'local', //标识本地开发
  DEV: 'zjdev',
  TEST: 'zjst',
  PRE: 'zjpre',
  PRODUCT: 'zjga',
};

const { publicRuntimeConfig } = getConfig();

const DOP_API = {
  [ENV_IDENTIFIER.DEV]: {
    LOGIN_PATH: 'https://k8sdev.cscec3b-iti.com/',
    ENV_ALIAS: 'dev',
  },
  [ENV_IDENTIFIER.TEST]: {
    LOGIN_PATH: 'https://k8stest.cscec3b-iti.com/',
    ENV_ALIAS: 'test',
  },
  [ENV_IDENTIFIER.PRE]: {
    LOGIN_PATH: 'https://k8spt.cscec3b-iti.com/',
    ENV_ALIAS: 'pre',
  },
  [ENV_IDENTIFIER.PRODUCT]: {
    LOGIN_PATH: 'https://k8s.cscec3b-iti.com/',
    ENV_ALIAS: 'prod',
  },
};

const X_APP_ID_DICT = {
  [ENV_IDENTIFIER.DEV]: {
    ID: 'f5049f3721894850bd915dc5f2bfba30', // 融合clientID
    TOP_ID: '04232d6cc95d47bf82e60cdcc5b9a148', // 独立访问时的clientID
    ORIGIN: 'https://mall-dev.3jyx.cn',
  },
  [ENV_IDENTIFIER.TEST]: {
    ID: 'f5049f3721894850bd915dc5f2bfba30',
    TOP_ID: '04232d6cc95d47bf82e60cdcc5b9a148', // 独立存在时的id
    ORIGIN: 'https://mall-st.3jyx.cn',
  },
  [ENV_IDENTIFIER.PRE]: {
    ID: 'f5049f3721894850bd915dc5f2bfba30',
    TOP_ID: '04232d6cc95d47bf82e60cdcc5b9a148', // 独立存在时的id
    ORIGIN: 'https://www.3jyx.cn',
  },
  [ENV_IDENTIFIER.PRODUCT]: {
    ID: 'f5049f3721894850bd915dc5f2bfba30',
    TOP_ID: '04232d6cc95d47bf82e60cdcc5b9a148', // 独立存在时的id
    ORIGIN: 'https://www.3jyx.cn',
  },
};

export const IS_LOCAL = !publicRuntimeConfig.ENV;
// console.log('publicRuntimeConfig.ENV... ', publicRuntimeConfig.ENV);
export const BASEURL_DOP = DOP_API[publicRuntimeConfig.ENV || ENV_IDENTIFIER.DEV]?.LOGIN_PATH;
export const X_APP_TOP_ID = X_APP_ID_DICT[publicRuntimeConfig.ENV || ENV_IDENTIFIER.DEV]?.TOP_ID;
export const X_APP_ID = X_APP_ID_DICT[publicRuntimeConfig.ENV || ENV_IDENTIFIER.DEV]?.ID;
export const X_APP_ORIGIN = X_APP_ID_DICT[publicRuntimeConfig.ENV || ENV_IDENTIFIER.DEV]?.ORIGIN;
